const API_BASE_URL = process.env.REACT_APP_BASE_API_URL;

export const updateAdmin = async (id, userData) => {

  const token = localStorage.getItem('token');
  if (!token) {
    console.error('[updateAdmin] Ошибка: Токен авторизации не найден.');
    throw new Error('Токен авторизации не найден.');
  }

  try {
    const response = await fetch(`${API_BASE_URL}/admin/user/admin-accounts/${id}`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`,
        'Accept': 'application/json',
      },
      body: JSON.stringify(userData),
    });

    if (!response.ok) {
      const errorData = await response.json();
      console.error('[updateAdmin] Ошибка обновления данных администратора:', errorData);
      throw { ...errorData, statusCode: response.status };
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error('[updateAdmin] Ошибка сети или другая ошибка при обновлении администратора:', error);
    throw error;
  }
};